/** Material Symbols Outlined helpers (flat icons). */
export function icon(name: string, className = ''): string {
  const cls = ['material-symbols-outlined', className].filter(Boolean).join(' ');
  return `<span class="${cls}" aria-hidden="true">${name}</span>`;
}

export function createIcon(name: string, className = ''): HTMLSpanElement {
  const span = document.createElement('span');
  span.className = ['material-symbols-outlined', className].filter(Boolean).join(' ');
  span.setAttribute('aria-hidden', 'true');
  span.textContent = name;
  return span;
}

export function setIcon(el: HTMLElement, name: string, className = ''): void {
  el.className = ['material-symbols-outlined', className].filter(Boolean).join(' ');
  el.setAttribute('aria-hidden', 'true');
  el.textContent = name;
}
